import React from "react";
import { motion } from "framer-motion";
import { useReducedMotion } from "@/hooks/useReducedMotion";
import styles from "./LoadingSpinner.module.css";

interface LoadingSpinnerProps {
  size?: "small" | "medium" | "large";
  text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "medium",
  text,
}) => {
  const prefersReducedMotion = useReducedMotion();

  const dotVariants = {
    start: { y: 0 },
    end: {
      y: prefersReducedMotion ? 0 : -10,
      transition: {
        duration: 0.5,
        repeat: Infinity,
        repeatType: "reverse" as const,
        ease: "easeInOut",
      },
    },
  };

  const containerVariants = {
    start: {
      transition: {
        staggerChildren: 0.1,
      },
    },
    end: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  return (
    <div className={`${styles.spinnerContainer} ${styles[size]}`}>
      {prefersReducedMotion ? (
        <div className={styles.staticSpinner} />
      ) : (
        <motion.div
          className={styles.dotsContainer}
          variants={containerVariants}
          initial="start"
          animate="end"
        >
          <motion.div className={styles.dot} variants={dotVariants} />
          <motion.div className={styles.dot} variants={dotVariants} />
          <motion.div className={styles.dot} variants={dotVariants} />
        </motion.div>
      )}
      {text && <p className={styles.text}>{text}</p>}
    </div>
  );
};
